import {ReactElement} from "react"
import {BrowserRouter, Route, Routes} from "react-router-dom"
import {Authenticated, Refine} from "@refinedev/core"
import {NavigateToResource, UnsavedChangesNotifier,} from "@refinedev/react-router-v6"
import {ErrorComponent, ThemedLayoutV2} from "@refinedev/antd"
import refineConfig from "./resources/refineConfig"
import {ColorModeContextProvider} from "./assets/header/ColorMode"
import {Header} from "./assets/header/Header"
import ActivityList from "./pages/activities/ActivityList"
import ActivityCreate from "./pages/activities/ActivityCreate"
import ActivityShow from "./pages/activities/ActivityShow"
import ActivityEdit from "./pages/activities/ActivityEdit"
import DeepLink from "./pages/deeplink/DeepLink"
import "@refinedev/antd/dist/reset.css"

export default function App(): ReactElement | null {
    return (
        <BrowserRouter>
            <ColorModeContextProvider>
                <Refine {...refineConfig()}>
                    <Authenticated key={'login'}>
                        <ThemedLayoutV2 Header={() => <Header/>} Sider={() => <></>}>
                            <Routes>
                                <Route index element={<NavigateToResource resource="activity"/>}/>
                                <Route path="/activity">
                                    <Route index element={<ActivityList/>}/>
                                    <Route path="create" element={<ActivityCreate/>}/>
                                    <Route path="show/:id" element={<ActivityShow/>}/>
                                    <Route path="edit/:id" element={<ActivityEdit/>}/>
                                </Route>
                                <Route path="/lti" element={<DeepLink/>}/>
                                <Route path="*" element={<ErrorComponent/>}/>
                            </Routes>
                            <UnsavedChangesNotifier/>
                        </ThemedLayoutV2>
                    </Authenticated>
                </Refine>
            </ColorModeContextProvider>
        </BrowserRouter>
    );
}
